import React, { Component } from 'react';
import Modal from 'rc-dialog';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import { ModalProps } from 'stores/ModalStore';

import ModalHeader from 'components/Modals/Components/ModalHeader/ModalHeader';
import ModalBody from 'components/Modals/Components/ModalBody/ModalBody';

import style from './VideoPlayerModal.module.scss';

interface Props extends ModalProps {
  titleId?: string;
  src: string;
  type?: string;
}

@observer
class VideoPlayerModal extends Component<Props> {
  render() {
    return (
      <Modal
        {...this.props}
        className={style.modal}
        destroyOnClose={true}
        animation="zoom"
        maskAnimation="fade"
        visible
      >
        <ModalHeader>
          <FormattedMessage
            id={this.props.titleId ?? 'modal.videoplayer.title'}
          />
        </ModalHeader>

        <ModalBody>
          <video className={style.video} controls>
            <source
              src={this.props.src}
              type={this.props.type ?? 'video/mp4'}
            />
          </video>
        </ModalBody>
      </Modal>
    );
  }
}

export default VideoPlayerModal;
